import PersistenceDocsFeature from '../../features/docs/persistence-feature';

export default function PersistenceDocsPage() {
  return <PersistenceDocsFeature />;
}
